<template>
  <b-modal
      ref="self"
      class="card-form-modal"
      :active="active"
      :custom-class="'dialog mpc'"
      has-modal-card
      trap-focus
      :destroy-on-hide="true"
      aria-role="dialog"
      scroll="keep"
      aria-modal
      @close="cancel">
    <template v-if="tip">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ nameWidjet }} widget</p>
          <button class="modal-close is-large active" aria-label="close" @click="cancel"></button>
        </header>
        <section class="modal-card-body">
          <p>
            This widget will redirect your customer to your branded portal at <a href="https://enhancify.com" target="_blank">enhancify.com</a>.
          </p>
        </section>
      </div>
    </template>
    <template v-if="code">
      <validation-observer v-slot="{ handleSubmit }">
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">{{ nameWidjet }} widget</p>
            <button class="modal-close is-large active" aria-label="close" @click="cancel"></button>
          </header>
          <section class="modal-card-body">
            <div class="modal-card-body-subtitle">
              Here's your code snippet for the {{ nameWidjetFull }} widget:
            </div>
            <b-field class="widget-code-wrapper">
              <textarea class="textarea" :value="code" ref="codeTextArea"
                        :readonly="true"></textarea>
            </b-field>
            <b-button class="is-success copy-code" :class="buttonClasses" @click="copyCode">
              Copy code
            </b-button>

            <div class="instruction">
              <div>
                <b>The following steps will help you embed the widget on your site:</b>
                <ol>
                  <template v-if="nameWidjet==='Full Page'">
                    <li>1) find a suitable page for the widget on your website, and a place
                      on it. The page should be empty: without any content, styles, etc.</li>
                  </template>
                  <template v-else>
                    <li>
                      1) find a suitable page for the widget on your website, and a place on it
                    </li>
                  </template>
                  <li>2) open the source code of your website</li>
                  <li>
                    3) determine the place in the code of your site corresponding to what you chose
                    in paragraph 1
                  </li>
                  <li>4) copy the widget code above</li>
                  <li>5) paste the widget code into the source code of your site</li>
                </ol>
              </div>

              <template v-if="nameWidjet==='Real'">
              <div>
                <b>Note:</b>
                <ol>
                  <li>• The text and size of the button can be set via the widget code. By default,
                    the button width is 400px, the minimum width is 300px, and the maximum width is
                    95% of the width of the block containing the button.</li>
                  <li>• When placing several real-widgets on one page, they will all be in the same
                    selected color scheme.</li>
                </ol>
              </div>
              </template>

              <div>
                <b>Warning:</b>
                <template v-if="nameWidjet==='Full Page'">
                  <div>
                    This widget is designed to fit the full width of the page. Please set it
                  to either body or container without padding on the left and right. <br> The widget
                    design is adapted for devices with a screen width of more than 320 pixels.
                  </div>
                  <br>
                </template>
                <div>
                  If you don’t know how to do it yourself, contact the specialist who helped you
                  make the website.
                </div>
              </div>
            </div>

            <form @submit.prevent="handleSubmit(submit)">
              <div class="email-box">
                <field
                    v-model.trim="email"
                    :editable="true"
                    rules="email|required|max:250" maxlength="250"
                    placeholder="example@gmail.com">
                </field>
                <b-button class="is-success" type="submit"
                        :disabled="!(!!email)"
                        :loading="emailSending" @click="handleSubmit(submit)">
                  Send code to e-mail
                </b-button>
              </div>
            </form>
          </section>
        </div>
      </validation-observer>
    </template>
  </b-modal>
</template>

<script>
import Field from '../Field.vue';

export default {
  name: 'GetCodeWidget',
  components: {
    Field,
  },
  props: {
    tip: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    code: {
      type: String,
      default: '<--code-->',
    },
    emailSending: {
      type: Boolean,
      default: false,
    },
    nameWidjet: {
      type: String,
      default: '',
    },
    nameWidjetFull: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      email: null,
    };
  },
  methods: {
    submit() {
      this.$emit('submit', this.email);
    },
    cancel() {
      this.$emit('close');
    },
    copyCode() {
      this.$refs.codeTextArea.select();
      document.execCommand('copy');
      this.copied = true;
      this.$buefy.toast.open({ message: 'Copied!', type: 'is-success', duration: 3000 });
    },
  },
  watch: {
    email(val) {
      this.email = val.replace(/\s/gu, '');
    },
  },
  computed: {
    buttonClasses() {
      switch (this.nameWidjet) {
        case 'Calculator':
          return 'copy-calculator-code';
        case 'Banner':
          return 'copy-banner-code';
        case 'Real':
          return 'copy-real-widget-code';
        case 'Full Page':
          return 'copy-full-page-widget-code';
        default:
          return '';
      }
    },
  },
};
</script>

<style scoped lang="stylus">
.modal-card-body >>> .field.widget-code-wrapper
  margin-bottom 5px
.dialog .modal-card .modal-card-body .field
  margin-top 0
.mpc
  >>> .animation-content
    max-width none !important
    width 600px
    .modal-close
      display none
      &.active
        display block
    @media(max-width:650px)
      width calc(100% - 10px)
  .copy-code
    font-size 19px
    width 100%
    margin 15px 0 20px
    text-transform uppercase
    height 48px
  .modal-card
    max-width 100%
    max-height 80vh
    height fit-content
    &-title
      text-align center
  .modal-card-body
    padding-bottom: 30px
    border-radius: 0 0 6px 6px
    p
      text-align center
    &-subtitle
      text-align left
      margin-bottom 10px
  .modal-close
    top 50%
    transform translateY(-50%)
    border none
  .textarea
    word-break break-all
  .instruction
    margin-bottom 20px
    ol
      list-style none
      margin-bottom 20px
    b
      display block
      margin-bottom 5px
.email-box
  display flex
  height 48px
  @media(max-width:650px)
    flex-direction column
    height auto
  button
    &.is-success
      font-size 19px
      text-transform uppercase
      background-color #68ba62
      &[disabled]
        background-color #8fa7b3
      @media(max-width:650px)
        height 48px
        margin-top 0
      &:not([disabled]):hover
        background-color #17b548
    width 40%
    height 100%
    border-radius 0 4px 4px 0
    @media(max-width:650px)
      width 100%
      margin-top: 30px
      border-radius 4px
  span
    width 60%
    height 100%
    @media(max-width:650px)
      width 100%
    >>> div
      width 100%
      height 48px
      margin 0 !important
    >>> input
      width 100%
      height 48px
      border-radius 3px 0 0 3px
      box-shadow none
      @media(max-width:650px)
        border-radius 4px
 .modal-close
   background none
   right 20px
</style>
